import React, { Component } from "react";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import { Div, Text } from "atomize";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class CampaignTestimonial extends Component {
  render() {
    const { content } = this.props;

    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div
            className="solutions"
            m={{ t: "7.7rem" }}
            bg="#1F1F1F"
            d="flex"
            flexDir={{xs: "column-reverse", md: "row"}}
            p={{ l: {xs: "1.6rem", md: "2.5rem"}, y: {xs: "3.5rem", md: "2rem"}, r:  {xs: "1.5rem", md: "1.75rem"} }}
          >
            <Div
              d="flex"
              justify="center"
              flexDir="column"
              p={{ r: {xs: "0", md: ".5rem", lg: "4rem"} }}
              flexGrow="1.3"
              m={{t: {xs: "4rem", md: "0"}}}
            >
              <Text textSize={{xs: "caption4", md: "title2"}} className="main-text" textWeight="700" m={{ b: "2rem" }}>
                "{content.text1}
              </Text>
              <Text textSize={{xs: "caption4", md: "title2"}} className="main-text" textWeight="700">
                {content.text2}”
              </Text>
            </Div>
            <Div flexGrow="1" m={{md: "auto"}}>
              <ImageLink link={content.imgLink}><Div
                pos="relative"
                bgImg={content.img}
                p={{ b: "100%" }}
                bgSize="cover"
                bgRepeat="no-repeat"
              >
                <Div pos="absolute" bottom="0" p={{ x: "1.1rem", b: ".8rem" }}>
                  <Text fontFamily="secondary" textWeight="700">
                    {content.imgName}
                  </Text>
                  <Text
                    fontFamily="secondary"
                    textWeight="700"
                    textSize="caption"
                  >
                    {content.imgBio}
                  </Text>
                </Div>
              </Div></ImageLink>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
